import { store } from '@/state/store';
import { invalid_type, not_implemented_type } from '@shared/asserts/utils_asserts';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { get_workspace_user } from './utils_workspace';

export function try_filter_grid2d_only_with_url_relative(grid2d: DTO__grid2d): DTO__grid2d {
  let out = grid2d.clone({ chunks: [] });

  for (let chunk of grid2d.chunks) {
    let out_chunk = chunk.clone({ cells_list: [] });

    let out_cells = chunk.cells_list.filter(cell => !cell.hash_sha256_content.is_empty_hash_sha256()); //keep only with content
    out_cells = out_cells.map(cell => cell.clone({ image: cell.image.clone() }));

    out_chunk.cells_list = out_cells;
    out_chunk.cells_amount = out_cells.length;
    out_chunk.images_amount = out_cells.length;

    out.total_cells_amount += out_chunk.cells_amount;
    out.total_images_amount += out_chunk.images_amount;

    out.chunk__upsert(out_chunk);
  }

  return out;
}

export function is_upload_image_to_grid_possible(entity: DTO__entity_with_grid2d) {
  if (!entity.is_add_external_image_possible()) return false;

  let current_workspace_user = get_workspace_user();

  let out = false;

  switch (entity.type) {
    case ENUM__workspace_entity.COLLECTION_CUSTOM:
    case ENUM__workspace_entity.COLLECTION_FAVORITES:
    case ENUM__workspace_entity.COLLECTION_UPLOADS:
      out = current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_UPDATE);
      break;

    case ENUM__workspace_entity.COLLECTION_GENERATED:
    case ENUM__workspace_entity.COLLECTION_VIEWED_ON_SEARCH:
    case ENUM__workspace_entity.ENTITY_GENERATION:
    case ENUM__workspace_entity.ENTITY_SEARCH:
      invalid_type(entity.type);
    default:
      not_implemented_type(entity.type);
  }

  return out;
}

export function is_grid2d_loading(entity_type: string, entity_id: string) {
  let key = get_grid2d_key(entity_type, entity_id);

  return store.getState().slice_grid2d.grid2d_loading_in_progress.has(key);
}

export function get_grid2d_key(entity_type: string, entity_id: string) {
  return `${entity_type}_${entity_id}`;
}
